import React, { useEffect } from "react";
import { Breadcrumb } from "antd";

const InfoDetail = ({ info = {}, goBack = () => {} }, ref) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <div style={{ padding: "20px 0", marginBottom: "1.8em" }}>
        <Breadcrumb separator=">">
          <Breadcrumb.Item>
            <a
              onClick={() => {
                goBack();
              }}
            >
              {info.name || "政策指南"}
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>详情</Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <div>
        <div
          style={{ overflow: "auto" }}
          dangerouslySetInnerHTML={{ __html: info.content || "" }}
        ></div>
      </div>
    </div>
  );
};

export default InfoDetail;
